/**
 ResultList Component **description**
 devs@droxit.de
 Copyright (c) 2019 droxIT GmbH
 **/

import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'

Vue.config.productionTip = false;

// bind click-outside directive to enable result container hiding
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      //source: https://github.com/ndelvalle/v-click-outside/blob/master/src/v-click-outside.js
      const path = event.path || (event.composedPath && event.composedPath());
      const isClickOutside = path
        ? path.indexOf(el) < 0
        : !el.contains(event.target);

      if (isClickOutside) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

Vue.directive('click-inside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      const path = event.path || (event.composedPath && event.composedPath());
      const isClickOutside = path
        ? path.indexOf(el) < 0
        : !el.contains(event.target);

      if (!isClickOutside) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

new Vue({
  i18n,
  render(h) {
    return h(App, {
      props: {
        //no props
      }
    })
  }
}).$mount('#rocketsearch-app')
